import React from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';
import './../../components/Information/styles.scss';

const Unicorn_Front = 'https://ik.imagekit.io/madeformefashion/tr:w-200/Products/Unicorn/Unicorn_Front.jpg';
const RuffleSleeves_Front = 'https://ik.imagekit.io/madeformefashion/tr:w-200/Products/RuffleSleeves/RuffleSleeves_Front.jpg';
const PinkSequinSandal_1 = 'https://ik.imagekit.io/madeformefashion/tr:w-200/Products/Accessories/PinkSequinSandal/PinkSequinSandal_1.jpg';
const ElsaSequin_Front = 'https://ik.imagekit.io/madeformefashion/tr:w-200/Products/ElsaSequin/ElsaSequin_Front.jpg';



const Reviews = () => {

    return (
        <div className="infoContainer">
            

            <h2 className="customers">
                What our customers say
            </h2>

            <div className='reviewContainer'>
                
                <div className='reviewContent'>
                    <Link to="/product/DeluxeUnicornCostumewithAccessories">
                        <img src={Unicorn_Front} alt={"UnicornFront"}/>
                    </Link>
                    <h4>A beautiful dress that also fits well to little girls of all sizes. Kashish, I couldn’t thank you enough for your expert help in selecting the right dress and size for my LO. Highly recommend the dress and personalised service.</h4>
                    <h5>- Mira</h5>
                </div>

                <div className='reviewContent'>
                    <Link to="/product/RuffleSleevesDress">
                        <img src={RuffleSleeves_Front} alt={"RuffleSleeves_Front"} />
                    </Link>
                    <h4>Dress arrived in time. It looks even better than the pictures. My daughter is very happy. Thank you!</h4>
                    <h5>- Catherine</h5>
                </div>

                <div className='reviewContent'>
                    <Link to="/product/PinkSequinShoes">
                        <img src={PinkSequinSandal_1} alt={"PinkSequinSandal_1"} />
                    </Link>
                    <h4>Shoes are gorgeous! my daughter wears them everywhere, she loves them. Thank you</h4>
                    <h5>- Sarah</h5>
                </div>

                <div className='reviewContent'>
                    <Link to="/product/ElsaSequinDress">
                        <img src={ElsaSequin_Front} alt={"ElsaSequinFront"} />
                    </Link>
                    <h4>Saw a similar dress at high-street store and it was pricier hence ordered from made for me fashion and I am satisfied with my purchase.</h4>
                    <h5>- Amy</h5>
                </div>

            </div>

            {/* <div className={classes.root}>
                <Paper className={classes.paper} >
                    <Grid container spacing={0}>
                        <Grid item sm={3} className="customerGrid">
                            <ButtonBase className="customerImg">
                                <Link to="/product/DeluxeUnicornCostumewithAccessories">
                                    <img src={Unicorn_Front} alt={"UnicornFront"} verticalalign={"center"}/>
                                </Link>
                            </ButtonBase>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2} >
                                <Grid item xs className="content">
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold"  >
                                    {"“A beautiful dress that also fits well to little girls of all sizes. Kashish, I couldn’t thank you enough for your expert help in selecting the right dress and size for my LO. Highly recommend the dress and personalised service”."} 
                                    </Typography>
                                    <Rating name="read-only" value={5} readOnly />
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"- Mira"} 
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className={classes.paper}>
                    <Grid container spacing={0} direction="row-reverse" >
                        <Grid item className="customerGrid">
                            <ButtonBase className="customerImg">
                                <Link to="/product/RuffleSleevesDress">
                                    <img src={RuffleSleeves_Front} alt={"RuffleSleeves_Front"} />
                                </Link>
                            </ButtonBase>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2}>
                                <Grid item xs className="content">
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"“Dress arrived in time. It looks even better than the pictures. My daughter is very happy. Thank you!”"} 
                                    </Typography>
                                    <Rating name="read-only" value={5} readOnly />
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"- Catherine"} 
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className={classes.paper}>
                    <Grid container spacing={0} >
                        <Grid item sm={3} className="customerGrid">
                            <ButtonBase className="customerImg">
                                <Link to="/product/PinkSequinShoes">
                                    <img className={classes.img} src={PinkSequinSandal_1} alt={"PinkSequinSandal_1"} />
                                </Link>
                            </ButtonBase>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2}>
                                <Grid item xs className="content">
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"“Shoes are gorgeous! my daughter wears them everywhere, she loves them. Thank you”"} 
                                    </Typography>
                                    <Rating name="read-only" value={5} readOnly />
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"- Sarah"} 
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className={classes.paper}>
                    <Grid container spacing={0} direction="row-reverse" >
                        <Grid item className="customerGrid">
                            <ButtonBase className="customerImg">
                                <Link to="/product/ElsaSequinDress">
                                    <img src={ElsaSequin_Front} alt={"ElsaSequinFront"} />
                                </Link>
                            </ButtonBase>
                        </Grid>
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" spacing={2}>
                                <Grid item xs className="content">
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"“Saw a similar dress at high-street store and it was pricier hence ordered from made for me fashion and I am satisfied with my purchase.”"} 
                                    </Typography>
                                    <Rating name="read-only" value={5} readOnly />
                                    <Typography gutterBottom variant="h5" fontWeight="fontWeightBold" >
                                    {"- Amy"} 
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>


            </div> */}

        </div>
    )
}

export default Reviews;
